import { Navigate, generatePath } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { NewOptionEditPresenter } from "./presenter";
import { useOptionEditQuery } from "../../../model/repository/new";

type Props = {
	hotelID: string;
	optionID: string | undefined;
	activeLangCode: LangCode;
};

export const NewOptionEditContainer = ({ hotelID, optionID, activeLangCode }: Props) => {
	const serverModel = useOptionEditQuery({ hotelID, optionID });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.ITEMS.OPTION.TOP, { hotelID })} />;
	}

	return <NewOptionEditPresenter serverModel={serverModel} activeLangCode={activeLangCode} />;
};

NewOptionEditContainer.displayName = "NewOptionEditContainer";
